import React, {useEffect, useState} from 'react';
import { observer } from 'mobx-react-lite';
import {
  Button,
  Navbar,
  Alignment,
  AnchorButton,
  Divider,
  Dialog,
  Classes,
} from '@blueprintjs/core';
import FaGithub from '@meronex/icons/fa/FaGithub';
import FaDiscord from '@meronex/icons/fa/FaDiscord';
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { firestore, storage } from '../firebase';
import AvatarContent from "./avatar"
import HomeIcon from '@material-ui/icons/Home';
import BsDownload from "@meronex/icons/bs/BsDownload";
import ShareButton from "./shareButton"
import styled from 'polotno/utils/styled';
import FaRegLaughBeam from '@meronex/icons/fa/FaRegLaughBeam';
import UpdateSubscriptionModal from './updateSubscriptionModal';
import { useDispatch } from 'react-redux';
import actions from '../redux/actions';

const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const FreeTrial = styled('div')`padding: 6px;
    background: #F2220F;
    border-radius: 5px;
    font-weight: 600;`;

    const UpgradeSubs = styled('div')`padding: 0px;
    background: #7FA62D;
    border-radius: 5px;
    font-weight: 600;`;


const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;

export default observer(({ store, show, currentUser }) => {
  const inputRef = React.useRef();
  const [loading, setLoading] = useState(false)
  const [faqOpened, toggleFaq] = React.useState(false);
  const [showFreeTrial, setShowFreeTrial] = useState()
  const [modalOpen, setModalOpen] = useState(false)
  const dispatch = useDispatch()
  useEffect(()=>{
    if(new Date(currentUser.activationDate).getTime() > new Date().getTime()) {
      let days = new Date(currentUser.activationDate).getTime() - new Date().getTime();
      days = days / (24 * 60 * 60 * 1000)
      setShowFreeTrial(`Free Trial: ${parseInt(days)} Days Left`)
    }
  }, [])

  const savedDesign = async () => {
    setLoading(true)
    
    const base64 = store.toDataURL({ ignoreBackground: false });
    const child = `${currentUser.uid}/saved/${new Date().getTime()}`
    const storageRef = await storage.ref().child(child).putString(base64, 'data_url');
    const imageLink = await storageRef.ref.getDownloadURL();
    const json = store.toJSON();
    const j = JSON.parse(JSON.stringify(json))
    await firestore.collection("saved").add({
      userId: currentUser.uid,
      imageLink,
      data: j
    })
    setLoading(false)
  }

  const urlToImage = (url) => {
    return new Promise((resolve) => {
      const img = new window.Image();
      img.crossOrigin = "anonymous";
      img.src = url;
      img.onload = () => {
        resolve(img);
      };
    });
  };

  async function downloadFile(dataURL, filename) {
    const blob = await (await fetch(dataURL)).blob();
    const a = document.createElement("a");
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  const handleDownload = async () => {
    // export design
    const designURL = store.toDataURL();
    // conver it into image object
    const image = await urlToImage(designURL);
    // create external canvas
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    // draw design into canvas
    ctx.drawImage(image, 0, 0);

    // load watermark
    const watermark = await urlToImage("https://www.jazzudesigner.com/assets/Made with Jazzu Designer.png");
    // draw watermark
    ctx.drawImage(
      watermark,
      canvas.width - watermark.width,
      canvas.height - watermark.height
    );
    // export final resutl
    const resultURL = canvas.toDataURL();
    // download it
    downloadFile(resultURL, "jazzu-designer.png");
  };

  const downloadImage = async ()=>{
    store.saveAsImage({ fileName: 'jazzu-designer.png' });
  }

  const openModal = () => {
    dispatch({
      type: actions.SET_STATE,
      payload: {newUser: currentUser}
    })
    setModalOpen(true)
  }


  return (
    <NavbarContainer className="bp3-dark bp3-navbar">
    <Backdrop open={loading} style={{ zIndex: 15000 }}>
      <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
    </Backdrop>
      <NavInner>
        <Navbar.Group align={Alignment.LEFT}>
        {show ?
          <>
            <Button
              icon="new-object"
              minimal
              onClick={() => {
                const ids = store.pages
                  .map((page) => page.children.map((child) => child.id))
                  .flat();
                const hasObjects = ids?.length;
                if (hasObjects) {
                  if (!window.confirm('Remove all content for a new design?')) {
                    return;
                  }
                }
                const pagesIds = store.pages.map((p) => p.id);
                store.deletePages(pagesIds);
                store.addPage();
              }}
            >
              New
            </Button>
            <label htmlFor="load-project">
              <Button
                icon="folder-open"
                minimal
                onClick={() => {
                  document.querySelector('#load-project').click();
                }}
              >
                Open
              </Button>
              <input
                type="file"
                id="load-project"
                accept=".json,.polotno"
                ref={inputRef}
                style={{ width: '180px', display: 'none' }}
                onChange={(e) => {
                  var input = e.target;

                  if (!input.files.length) {
                    return;
                  }

                  var reader = new FileReader();
                  reader.onloadend = function () {
                    var text = reader.result;
                    let json;
                    try {
                      json = JSON.parse(text);
                    } catch (e) {
                      alert('Can not load the project.');
                    }

                    if (json) {
                      store.loadJSON(json);
                    }
                  };
                  reader.onerror = function () {
                    alert('Can not load the project.');
                  };
                  reader.readAsText(input.files[0]);
                }}
              />
            </label>
            <Button
              icon="floppy-disk"
              minimal
              onClick={() => savedDesign()}
            >
              Save
            </Button>
            {showFreeTrial &&<FreeTrial>
              {showFreeTrial} 
            </FreeTrial>
            }
            {showFreeTrial &&<UpgradeSubs>
              <Button
              icon="dollar"
              minimal
              onClick={() => openModal(true)}
            >
              Upgrade My Plan
            </Button> 
            </UpgradeSubs>
            }



            
          {/*}
            {showFreeTrial &&<FreeTrial onClick={() => openModal(true)}>
              Upgrade My Plan
            </FreeTrial>
            }
          {*/}
          </>:
          <HomeIcon onClick={()=>window.location.href = "/"}/>
        }
        </Navbar.Group>
      
        <Navbar.Group align={Alignment.RIGHT}> 
          {/* <a
          href="https://www.producthunt.com/posts/polotno-studio?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-polotno-studio"
          target="_blank"
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=281373&theme=dark"
            alt="Polotno Studio - Canva-like design editor, without signups or ads. | Product Hunt"
            style={{ height: '30px', marginBottom: '-4px' }}
          />
        </a> */}
        {/*
          <AnchorButton
            minimal
            href="https://jazzubai-memes.com"
            target="_blank"
            icon={
              <FaRegLaughBeam className="bp3-icon" style={{ fontSize: '20px' }} />
            }
          >
            Memes
          </AnchorButton>
          */}
          <ShareButton />
          <Button icon="info-sign" minimal onClick={() => toggleFaq(true)}>
            About
          </Button>
          <Divider />
          {show &&<button
            type="button"
            className="bp3-button"
          
            //onClick={downloadImage}
            onClick={handleDownload}
          >
            <BsDownload icon="upload" />
            <span className="bp3-button-text">Download</span>
          </button>}
          <AvatarContent />
        </Navbar.Group>
        <Dialog
          icon="info-sign"
          onClose={() => toggleFaq(false)}
          title="About Jazzu Designer"
          isOpen={faqOpened}
          style={{
            width: '80%',
            maxWidth: '700px',
          }}
        >
          <div className={Classes.DIALOG_BODY}>
            {/*<h2>What is Jazzu Designer?</h2>*/}
            <p>
              <strong>Jazzu Designer</strong> - is an easy to use graphics design tool that was built by graphic designers, for graphic designers. Simply drag and drop from the full library of graphics included with Jazzu Designer and create amazing designs in minutes! This all-in-one graphics design tool also contains premium 3D Characters! 
            </p>
            {/*
            <h2>You want to make passive income?</h2>
            <p>
              All of us looking forward to earn passive income. But you have failed after trying with many methods. Check{' '}
              <a
                href="\"
                target="_blank"
              >
                Jazzubai Memes
              </a>
              . Post your memes in this website, and sit down and relax , you will earn money every month. You can check your 'Memes Wallet' any time for money earned.
            </p>
            <p>
              Check it out at{' '}
              <a
                href="\"
                target="_blank"
              >
                Jazzubai Memes
              </a>
              . Good luck.
            </p>
            */}
           </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={() => toggleFaq(false)}>Close</Button>
            </div>
          </div>
        </Dialog>
      </NavInner>
      {modalOpen && <UpdateSubscriptionModal setOpen={setModalOpen}/>}
    </NavbarContainer>
  );
});
